export class UserModel implements IUserModel {
    // EMAIL
    public email: string;
    // ONBEHALFOF
    public onBehalfOf: string;
    // FIRSTNAME
    public firstName: string;
    // LASTNAME
    public lastName: string;
    // DATE OF BIRTH
    public dateOfBirth: Date;
    // MOBILEPHONE
    public mobilePhone: string;
    // USERTYPE
    public userType: string;
    // ISPASSWORDRESETREQUIRED
    public isPasswordResetRequired: boolean;
    // ID
    public id: number;
    // CURRENTSTAGENUMBER
    public stageLuid: number;
    // STATUS
    public status: string;

    public enrollmentProgramAlias: string;

    public sessionExpDate: Date;

    public programTitle: string;
    currentStageNumber: number;

    backgroundImgId: number;

    isUpdateEnabled: boolean;
    public isProvider: boolean;
    orgName: string;

    public sourceDate: Date;

    public providerScreenedFlag: boolean;
    public pyndexTransferredFlag: boolean;
    public acknowledgementStatus: boolean;

    public documentRequested: boolean;


    constructor(data: IUserModel) {
        this.email = data.email;
        this.onBehalfOf = data.onBehalfOf;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.dateOfBirth = data.dateOfBirth;
        this.mobilePhone = data.mobilePhone;
        this.userType = data.userType;
        this.isPasswordResetRequired = data.isPasswordResetRequired;
        this.id = data.id;
        this.stageLuid = data.stageLuid;
        this.status = data.status;
        this.sessionExpDate = data.sessionExpDate;
        this.programTitle = data.programTitle;
        this.enrollmentProgramAlias = data.enrollmentProgramAlias;
        this.currentStageNumber = data.currentStageNumber;
        this.backgroundImgId = data.backgroundImgId;
        this.isUpdateEnabled = data.isUpdateEnabled;
        this.orgName = data.orgName;
        this.sourceDate = new Date();
        this.providerScreenedFlag = data.providerScreenedFlag;
        this.pyndexTransferredFlag = data.pyndexTransferredFlag;
        this.acknowledgementStatus = data.acknowledgementStatus;
        this.documentRequested = data.documentRequested;
        this.isProvider = false;
    }

}

interface IUserModel {
    // EMAIL
    email: string;
    // INBEHALFOF
    onBehalfOf: string;
    // FIRSTNAME
    firstName: string;
    // LASTNAME
    lastName: string;
    //DATE OF BIRTH 
    dateOfBirth: Date; 
    // MOBILEPHONE
    mobilePhone: string;
    // USERTYPE
    userType: string;
    // ISPASSWORDRESETREQUIRED
    isPasswordResetRequired: boolean;
    // ID
    id: number;
    // CURRENTSTAGENUMBER
    stageLuid: number;
    // STATUS 
    status: string;

    sessionExpDate: Date;

    programTitle: string;
    enrollmentProgramAlias: string;

    currentStageNumber: number;
    backgroundImgId: number;

    isUpdateEnabled: boolean;
    isProvider: boolean;
    orgName: string;

    sourceDate: Date;
    providerScreenedFlag: boolean;
    pyndexTransferredFlag: boolean;
    acknowledgementStatus: boolean;
    documentRequested: boolean;

}


// WEBPACK FOOTER //
// ./src/app/shared/models/user-info.model.ts